export default class PostalCodeService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getAllPostalCodes(args) {
    return this.axiosIns.get(this.serviceConfig.postalCode, { params: args });
  }

  createPostalCode(...args) {
    return this.axiosIns.post(this.serviceConfig.postalCode, ...args);
  }

  editPostalCode(id, args) {
    return this.axiosIns.put(`${this.serviceConfig.postalCode}/${id}`, args);
  }

  getPostalCode(postalCodeId) {
    return this.axiosIns.get(`${this.serviceConfig.postalCode}/${postalCodeId}`);
  }

  deletePostalCode(id) {
    return this.axiosIns.delete(`${this.serviceConfig.postalCode}/${id}`);
  }

  autoPostalCodes(args) {
    return this.axiosIns.post('/api/v1/postal_codes/auto_fill', args);
  }

  searchAddress(args) {
    return this.axiosIns.get(`/api/v1/address/search?${args}`);
  }
}
